var _polyline, _line, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "85px",
    height: "85px",
    viewBox: "0 0 85 85",
    enableBackground: "new 0 0 85 85",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 66.718,48.696 66.718,42.424 18.281,42.424 18.281,48.696 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 42.5,
    y1: 36.563,
    x2: 42.5,
    y2: 48.67
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.328,
    y: 16.552,
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 12.344,
    height: 12.346
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 36.326,
    y: 56.103,
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 12.348,
    height: 12.346
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.047,
    y: 56.103,
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 12.346,
    height: 12.346
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.606,
    y: 56.103,
    fill: "none",
    stroke: "#037FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 12.346,
    height: 12.346
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.b0dea6a3ea559ae8aca50e9728094939.svg";
export { ForwardRef as ReactComponent };